uniform float uTime;
uniform float uFrequency;
uniform float uAmplitude;
uniform float uSpeed;
uniform float uHeight;

varying vec3 vNormal;
varying vec3 vPosition;

#include <common>

void main() {
#include <begin_vertex>
    
float mask = smoothstep(0.0, uHeight, transformed.y);
    float wave = sin(transformed.z * uFrequency + uTime * uSpeed);
    transformed.x += wave * uAmplitude * mask;

    #include <beginnormal_vertex>
    #include <defaultnormal_vertex>
    #include <project_vertex>

    // 3. Update Varyings for Fragment Shader
    // We need the World Position of the *deformed* mesh for correct lighting/effects
    vec4 worldPosition = modelMatrix * vec4(transformed, 1.0);
    vPosition = worldPosition.xyz;

    // Normal Matrix transforms normals from Local to View space. 
    // Usually vNormal is handled by Three.js chunks, but if you need a custom one:
    vNormal = normalize(normalMatrix * objectNormal); 
}